import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Collapse, List } from '@mui/material';
import classNames from "classnames";
import SidebarRoutes from 'Mocks/SidebarRoutes';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
    const { pathname } = useLocation();
    const basePath = pathname.split("/")[1];
    const subPath = pathname.split("/")[2];
    const [openMenu, setOpenMenu] = useState({});

    useEffect(() => {
        if (basePath) {
            setOpenMenu(prevState => ({
                ...prevState,
                [basePath]: true
            }));
        }
    }, [basePath]);

    const handleToggle = (basePath) => {
        setOpenMenu(prevState => ({
            ...prevState,
            [basePath]: !prevState[basePath]
        }));
    };

    return (
        <div className="flex flex-col border bg-white shadow-md p-1  overflow-y-auto">
            {SidebarRoutes.map((route, index) => (
                <div key={index}>
                    {route?.subRoutes ?
                        <>
                            <Link
                                to={`/${route.basePath}`}
                                onClick={() => handleToggle(route.basePath)}
                                className={classNames(
                                    "p-3 px-4 w-full flex items-center justify-between rounded-lg text-sm",
                                    basePath === route.basePath ? "bg-blue-700 text-white" : "hover:bg-gray-100"
                                )}
                            >
                                <span className="flex items-center gap-x-2">
                                    {route.icon}
                                    {route.title}
                                </span>
                                {openMenu[route.basePath] ? <ExpandMoreIcon /> : <NavigateNextIcon />}
                            </Link>
                            <Collapse
                                in={openMenu[route.basePath]}
                                timeout="auto"
                                unmountOnExit
                                className="border border-gray-300 rounded-lg m-1 mt-1 bg-gray-50 shadow-sm !p-0 !overflow-hidden"
                                sx={{
                                    "& .MuiList-root": {
                                        padding: 0,
                                    }
                                }}
                            >
                                <List className="flex flex-col py-0 w-full">
                                    {route.subRoutes.map((subRoute, subIndex) => (
                                        <Link
                                            key={subIndex}
                                            className={classNames(
                                                "p-3 px-4 text-sm block",
                                                subPath === subRoute.path ? "bg-blue-100 text-blue-800" : "hover:bg-gray-100"
                                            )}
                                            to={`/${route.basePath}/${subRoute.path}`}
                                        >
                                            {subRoute.label}
                                        </Link>
                                    ))}
                                </List>
                            </Collapse>
                        </>
                        :
                        <Link
                            to={`/${route.basePath}`}
                            onClick={() => handleToggle(route.basePath)}
                            className={classNames(
                                "p-3 px-4 w-full flex items-center justify-between rounded-lg text-sm",
                                basePath === route.basePath ? "bg-blue-700 text-white" : "hover:bg-gray-100"
                            )}
                        >
                            <span className="flex items-center gap-x-2">
                                {route.icon}
                                {route.title}
                            </span>
                        </Link>
                    }
                </div>
            ))}
        </div>
    );
};

export default Sidebar;
